import React from 'react';
import { Div, SubText, DraftDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const UnidPlanPdfNotAvailable = ({ onClose }) => {
    const {t} = useTranslation();
    return (
        <>
            <Popup id={'surgery-notification-unidPlanPdfNotAvailable-popup'} onClose={onClose} title={t('scheduleSurgery.surgery.notifications.UnidPlanPdfNotAvailable.UnidPlanPdfNotAvailable')}>
                <DraftDiv>
                    <SubText>
                        {t('scheduleSurgery.surgery.notifications.UnidPlanPdfNotAvailable.contactUnidLab')}
                    </SubText>
                    <Div>
                        <Button
                            id={'surgery-notifications-unidplanpdfnotavailable-okbutton'}
                            variant={ButtonStyles?.primary}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            //  primary={true}
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                            {t('scheduleSurgery.surgery.notifications.UnidPlanPdfNotAvailable.okButton')}
                        </Button>
                    </Div>
                </DraftDiv>
            </Popup>
        </>
    );
};

export default UnidPlanPdfNotAvailable;
